import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async ({gateway, fields, perPage, page, userId}) => {
  const qb = RequestQueryBuilder.create();

  if(gateway) { qb.setFilter({ field: "gateway", operator: "$eq", value: gateway }) }
  if(userId) { qb.setFilter({ field: "user.id", operator: "$eq", value: userId }); }

  qb.setFilter({ field: "user.isReady", operator: "$eq", value: true });

  qb.setPage(page);
  qb.setLimit(perPage);
  qb.setOffset(perPage * page);
  qb.setJoin({field: 'user', select: ['id', 'name', 'surname']});
  qb.setJoin({field: 'device', select: ['id', 'name', 'surname']});
  qb.select(fields);

  const response = await Http.get('admin/sessions', {
    params: qb.queryObject
  });

  return response.data;
}
